import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "m-formGroup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailField = _resolveComponent("EmailField")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.config.type === _ctx.FormFieldType.Email)
      ? (_openBlock(), _createBlock(_component_EmailField, {
          key: 0,
          config: _ctx.config,
          state: _ctx.state,
          onStateChange: _ctx.handleStateChange
        }, null, 8, ["config", "state", "onStateChange"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noticeList, ([key, error]) => {
      return _withDirectives((_openBlock(), _createElementBlock("p", {
        key: key,
        class: "m-formGroup__notice"
      })), [
        [_directive_translate, error]
      ])
    }), 128))
  ]))
}